// package/server-ee/app/react/portainer/environments/ItemView/AccessView/EnvironmentDetailsWidget.tsx

import { HardDrive } from 'lucide-react';

import { Environment } from '@/react/portainer/environments/types';
import { EnvironmentGroup } from '@/react/portainer/environments/environment-groups/types';
import { stripProtocol } from '@/portainer/filters/filters';

import { Link } from '@@/Link';
import { WidgetTitle, WidgetBody, Widget } from '@@/Widget';

interface Props {
  environment: Environment;
  group: EnvironmentGroup;
}

export function EnvironmentDetailsWidget({ environment, group }: Props) {
  return (
    <div className="row">
      <div className="col-sm-12">
        <Widget aria-label="Environment details">
          <WidgetTitle icon={HardDrive} title="Environment" />
          <WidgetBody>
            <table className="table">
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{environment.Name}</td>
                </tr>
                <tr>
                  <td>URL</td>
                  <td>{stripProtocol(environment.URL)}</td>
                </tr>
                <tr>
                  <td>Group</td>
                  <td>
                    <Link
                      to="portainer.groups.group"
                      params={{ id: group.Id }}
                      data-cy="group-link"
                    >
                      {group.Name}
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </WidgetBody>
        </Widget>
      </div>
    </div>
  );
}
